import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#606060",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M24.273 7.678c.307.383.477.88.477 1.395 0 .514-.17 1.012-.477 1.395-1.942 2.35-6.363 6.928-11.523 6.928s-9.58-4.578-11.523-6.928A2.23 2.23 0 0 1 .75 9.073c0-.516.17-1.012.477-1.395C3.17 5.328 7.59.75 12.75.75s9.58 4.578 11.523 6.928"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#606060",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.754 12.771a3.7 3.7 0 1 0 0-7.398 3.7 3.7 0 0 0 0 7.398"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "eye"}) } }